<template>
  <div class="home-content-page-v">
    <div style="margin-bottom: 1rem;display: flex;">
      <el-select v-model="car_center" placeholder="配送中心">
        <el-option v-for="item in pszxDatas" :key="item.key" :label="item.label" :value="item.key">
        </el-option>
      </el-select>
      <el-select v-model="axle_key" placeholder="车轴筛选">
        <el-option v-for="item in AXLE_LIST" :key="item.key" :label="item.label" :value="item.key">
        </el-option>
      </el-select>
      <div>
      <el-input v-model="s_car_id" placeholder="请输入车牌号"></el-input>
      </div>
      <div class="file-input" v-if="showQiandao">
        <span style="color: #777;font-size: 1rem;margin-right:1rem;">导入签到</span>
        <input type="file" @change="qdFileChange" id="file-4">
      </div>
    </div>
    <content-title title="车辆管理" :actions="titleAction" @clickMenu="clickTitleMenu"></content-title>
    <div class="output-content" v-loading="loading">
      <mii-base-table :datas="searchCar()" :table_actions="table_actions" :table_style="2" :ths="ths" @clickTdBtn="clickTdBtn" :show_checkbox="showQiandao"></mii-base-table>
    </div>
    <el-dialog :title="isNew ? '新增车辆' : '修改车辆'" :visible.sync="showAdd">
      <div class="case-form">
        <div class="one-input">
          <span>车牌号</span>
          <el-input v-model="carMap['车牌号']" size="small" :disabled="!isNew" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>配送中心</span>
          <el-input v-model="carMap['配送中心']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>承运商</span>
          <el-input v-model="carMap['承运商']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>牵引车</span>
          <el-input v-model="carMap['牵引车']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>车辆轴数</span>
          <el-select v-model="carMap['车辆轴数']" placeholder="请选择" size="small">
            <el-option v-for="item in AXLE_LIST.slice(0, -1)" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>停车点</span>
          <el-select v-model="carMap['停车油库代码']" placeholder="请选择" size="small">
            <el-option v-for="item in depotList" :key="item['油库代码']" :label="item['油库名称']" :value="item['油库代码']">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>驾驶员</span>
          <el-select v-model="carMap['司机']" filterable placeholder="请选择" size="small">
            <el-option v-for="(item, index) in driver_list" :key="item['姓名'] + index" :label="item['姓名']" :value="item['姓名']">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>道路运输证准运油品</span>
          <el-select v-model="carMap['道路运输证准运油品']" placeholder="请选择" size="small">
            <el-option v-for="item in ['汽油', '柴油']" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>电子运单装载油品</span>
          <el-select v-model="carMap['电子运单装载油品']" placeholder="请选择" size="small">
            <el-option v-for="item in ['汽油', '柴油']" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>合计</span>
          <el-input v-model="carMap['合计']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>前仓</span>
          <el-input v-model="carMap['前仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>中仓</span>
          <el-input v-model="carMap['中仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>后仓</span>
          <el-input v-model="carMap['后仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>通行证</span>
          <el-select v-model="carMap['通行证']" placeholder="请选择" size="small">
            <el-option v-for="item in PASS_LIST" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="saveCar">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="油品变更" :visible.sync="showChange">
      <div class="case-form" v-if="Number(carMap['更改油品']) === 1">
        <span>油品已变更，变更信息如下</span>
      </div>
      <div class="case-form">
        <div class="one-input">
          <span>车牌号</span>
          <el-input v-model="changeOil['车牌号']" size="small" :disabled="!isNew" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>更改油品</span>
          <el-select v-model="changeOil['更改油品']" placeholder="请选择" size="small">
            <el-option v-for="item in ['汽油', '柴油']" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>实际油品容积和</span>
          <el-input v-model="changeOil['实际油品容积和']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>前仓</span>
          <el-input v-model="changeOil['前仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>中仓</span>
          <el-input v-model="changeOil['中仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>后仓</span>
          <el-input v-model="changeOil['后仓']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>品名变更记录</span>
          <el-input v-model="changeOil['品名变更记录']" size="small" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChange = false">取 消</el-button>
        <el-button type="primary" @click="delChangeCarOilType" v-if="Number(carMap['更改油品']) === 1">取消变更</el-button>
        <el-button type="primary" @click="setCarOilType" v-else>确定变更</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="carMap['车牌号'] + ' >>> 限制可配送油站'" :visible.sync="showGasXz">
      <div class="case-form xz-gas">
        <div class="one-input">
          <span>可配送油站</span>
          <div class="gas-list">
            <strong v-if="!xzGasList || xzGasList.length === 0">没有可配送油站限制</strong>
            <span v-for="data in xzGasList" v-else>{{data['加油站名称']}}<i class="icon-105 iconfont" @click="delXzGas(data)"></i></span>
          </div>
        </div>
      </div>
      <div class="case-form">
        <div class="one-input">
          <span>添加油站</span>
          <el-select v-model="selectGas" filterable placeholder="请输入关键词">
            <el-option v-for="item in gasList" :key="item['油站代码']" :label="item['加油站名称']" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="case-form" style="color: #888;font-size: 1rem;">
          <span>添加可配送油站后，该车辆只能配送指定加油站。</span>
        </div>
        <el-button @click="showGasXz = false">取 消</el-button>
        <el-button type="primary" @click="setGasXz">保存限制</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showDel" size="tiny">
      <span>你确定删除该车辆吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="delCar">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showCheckData" size="large">
      <div v-loading="loadingWarning">
      <content-title title="未签到异常车辆" v-if="warningDataWqd.length > 0"></content-title>
      <div class="output-content" v-if="warningDataWqd.length > 0">
      <mii-base-table :datas="warningDataWqd" :table_style="2" :ths="thsW"></mii-base-table>
    </div>
    <content-title title="已签到异常车辆" v-if="warningDataQd.length > 0"></content-title>
      <div class="output-content" v-if="warningDataQd.length > 0">
      <mii-base-table :datas="warningDataQd" :table_style="2" :ths="thsW"></mii-base-table>
    </div>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCheckData = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showQdError">
      <div>
        <content-title title="导入文件签到异常数据"></content-title>
        <div class="output-content">
          <mii-base-table :datas="errorData" :table_style="2" :ths="thsE"></mii-base-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQdError = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
import {
  car,
  driver,
  gas
} from '@/api/oli_api'
import {
  PASS_LIST,
  AXLE_LIST
} from '@/api/static_data'

let warningTypes = {
  'carStatusWaring': '车辆状态异常',
  'blackCar': '车辆黑名单',
  'noDriver': '无驾驶员',
  'driverStatusWaring': '驾驶员状态异常',
  'blackDriver': '驾驶员黑名单',
  'tooEarly': '在途中',
  'late': '空闲中'
}

import {
  mapCp,
  readExcelFileData
} from '@/cllib'

let nulCar = {
  '车牌号': '',
  '配送中心': '',
  '承运商': '',
  '牵引车': '',
  '车辆轴数': '',
  '核定载质量': '',
  '道路运输证准运油品': '',
  '电子运单装载油品': '',
  '合计': '',
  '前仓': '',
  '中仓': '',
  '后仓': '',
  '通行证': '',
  '更改油品': '',
  '可配送油站限制': '',
  '停车油库代码': ''
}

let nulChangeOil = {
  '车牌号': '',
  '更改油品': '',
  '实际油品容积和': '',
  '前仓': '',
  '中仓': '',
  '后仓': '',
  '品名变更记录': ''
}

export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      showQdError: false,
      errorData: [],
      loadingWarning: false,
      warningData: [],
      showCheckData: false,
      driver_list: [],
      s_car_id: '',
      selectGas: null,
      xzGasList: [],
      depotList: [{'油库代码': '33450015', '油库名称': '云南昆东油库'}, {'油库代码': '33450016', '油库名称': '云南长坡油库'}, {'油库代码': '36910016', '油库名称': '云南中石油安宁炼厂地付库'}],
      gasList: [],
      isNew: false,
      PASS_LIST,
      AXLE_LIST,
      car_center: '',
      axle_key: '',
      carMap: mapCp(nulCar),
      changeOil: mapCp(nulChangeOil),
      loading: true,
      showDel: false,
      showAdd: false,
      showChange: false,
      showQiandao: false,
      showGasXz: false,
      titleAction: [{
        key: 'qiandaoCheck',
        icon: 'icon-duocengshujuxiaoyan'
      }],
      carList: [],
      ths: [{
        key: '车牌号',
        label: '车牌号'
      },
      {
        key: '牵引车',
        label: '牵引车'
      },
      {
        key: '核定载质量',
        label: '核定载质量'
      },
      {
        key: '合计',
        label: '合计仓容'
      },
      {
        key: '车辆轴数',
        label: '轴数'
      },
      {
        key: '道路运输证准运油品',
        label: '准运油品'
      },
      {
        key: '更改油品文字',
        label: '油品更改'
      },
      {
        key: '司机',
        label: '驾驶员'
      },
      {
        key: '人员状态',
        label: '驾驶员状态'
      },
      {
        key: '黑司机',
        label: '司机黑名单'
      },
      {
        key: '签到状态文字',
        label: '签到状态'
      },
      {
        key: 'STATUS',
        label: '车辆状态'
      },
      {
        key: '拉黑状态',
        label: '拉黑状态'
      }],
      thsE: [{
        key: '车牌号',
        label: '车牌号'
      },
      {
        key: 'errorInfo',
        label: '异常原因'
      }],
      thsW: [{
        key: '车牌号',
        label: '车牌号'
      },
      {
        key: '牵引车',
        label: '牵引车'
      },
      {
        key: '核定载质量',
        label: '核定载质量'
      },
      {
        key: '合计',
        label: '合计仓容'
      },
      {
        key: '车辆轴数',
        label: '轴数'
      },
      {
        key: '道路运输证准运油品',
        label: '准运油品'
      },
      {
        key: '更改油品文字',
        label: '油品更改'
      },
      {
        key: '司机',
        label: '驾驶员'
      },
      {
        key: '人员状态',
        label: '驾驶员状态'
      },
      {
        key: '黑司机',
        label: '司机黑名单'
      },
      {
        key: '签到状态文字',
        label: '签到状态'
      },
      {
        key: 'STATUS',
        label: '车辆状态'
      },
      {
        key: '拉黑状态',
        label: '拉黑状态'
      },
      {
        key: '异常原因',
        label: '异常原因'
      }]
    }
  },
  watch: {
    car_center () {
      this.loadCarList()
    },
    axle_key () {
      this.loadCarList()
    },
    selectGas (value) {
      if (value) {
        let inDatas = false
        this.xzGasList.forEach((item) => {
          if (item['油站代码'] === value['油站代码']) {
            inDatas = true
          }
        })
        if (!inDatas) {
          this.xzGasList.push(value)
        }
      }
    }
  },
  computed: {
    warningDataQd: {
      get () {
        let data = []
        this.warningData.forEach((item) => {
          if (item['签到状态'] === '1' || item['签到状态'] === 1) {
            data.push(item)
          }
        })
        return data
      }
    },
    warningDataWqd: {
      get () {
        let data = []
        this.warningData.forEach((item) => {
          if (item['签到状态'] !== '1' && item['签到状态'] !== 1) {
            data.push(item)
          }
        })
        return data
      }
    },
    pszxDatas: {
      get () {
        return this.$store.getters.canChoosePSZXs
      }
    },
    table_actionsw: {
      get () {
        let data = this.showQiandao ? [{
          label: '拉黑',
          key: 'black',
          hideByData: (data) => {
            return data['BLACK'] !== 'black'
          }
        },
        {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: (data) => {
            return data['BLACK'] === 'black'
          }
        }] : [{
          label: '改签',
          key: 'gq'
        },
        {
          label: '拉黑',
          key: 'black',
          hideByData: (data) => {
            return data['BLACK'] !== 'black'
          }
        },
        {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: (data) => {
            return data['BLACK'] === 'black'
          }
        }]
        return data
      }
    },
    table_actions: {
      get () {
        let data = this.showQiandao ? [{
          label: '编辑',
          key: 'edit'
        },
        {
          label: '更改油品',
          key: 'change_oil_type'
        },
        {
          label: '限制可配送油站',
          key: 'change_gas_xz'
        },
        {
          label: '拉黑',
          key: 'black',
          hideByData: (data) => {
            return data['BLACK'] !== 'black'
          }
        },
        {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: (data) => {
            return data['BLACK'] === 'black'
          }
        }] : [{
          label: '改签',
          key: 'gq'
        },
        {
          label: '编辑',
          key: 'edit'
        },
        {
          label: '更改油品',
          key: 'change_oil_type'
        },
        {
          label: '限制可配送油站',
          key: 'change_gas_xz'
        },
        {
          label: '拉黑',
          key: 'black',
          hideByData: (data) => {
            return data['BLACK'] !== 'black'
          }
        },
        {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: (data) => {
            return data['BLACK'] === 'black'
          }
        }]
        return data
      }
    }
  },
  created () {
    this.car_center = this.$store.getters.oilArea
    this.loadGasList()
    this.loadDriverList()
  },
  methods: {
    loadDriverList () {
      let parm = {
        action: 'get_driver',
        data: {}
      }
      driver(parm).then((data) => {
        this.driver_list = data
      })
    },
    qdFileChange (e) {
      let filePlant = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!filePlant) {
        document.getElementById('file-4').value = ''
      } else {
        this.inputOlderPlan({excelFile: filePlant, fileId: 'file-4'})
      }
    },
    checkFile (files) {
      if (!files.length) {
        return null
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0]
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        })
        return false
      }
    },
    searchCar () {
      let newData = []
      this.carList.forEach((item) => {
        if (item['车牌号'].indexOf(this.s_car_id) !== -1) {
          newData.push(item)
        }
      })
      return newData
    },
    inputOlderPlan ({excelFile, fileId}) {
      let sheets = [{
        needDataKeys: ['签到', '不签到']
      }]
      readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then((data) => {
        this.warningData = []
        this.errorData = []
        this.loading = true
        let allData = []
        for (let key in data) {
          data[key].forEach(function (item) {
            allData.push(item)
          })
        }
        let parm = {
          action: 'car_qd',
          data: {
            qdData: allData
          }
        }
        car(parm).then((data) => {
          console.log(data)
          if (data.code === '1') {
            this.errorData = data.error_data
            this.showQdError = true
          } else {
            this.showCheckData = true
            this.warningData = this.delWCarData(data)
            this.loadCarList()
          }
          this.loading = false
          document.getElementById(fileId).value = ''
        })
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        })
        document.getElementById(fileId).value = ''
        console.log(e)
      })
    },
    delXzGas (gas) {
      let newDatas = []
      this.xzGasList.forEach((item) => {
        if (item['油站代码'] !== gas['油站代码']) {
          newDatas.push(item)
        }
      })
      this.xzGasList = newDatas
    },
    loadGasList () {
      let parm = {
        action: 'get_gas',
        data: {}
      }
      gas(parm).then((data) => {
        this.gasList = data
      })
    },
    loadCarList () {
      this.loading = true
      let parm = {
        action: 'get_cars',
        data: {
          '配送中心': this.car_center,
          '车辆轴数': this.axle_key === '0' ? '' : this.axle_key
        }
      }
      car(parm).then((data) => {
        this.showQiandao = true
        this.titleAction = [{
          key: 'qiandaoCheck',
          icon: 'icon-duocengshujuxiaoyan'
        },
        {
          key: 'qiandao',
          icon: 'icon-qiandao'
        }]
        data.forEach((item) => {
          if (item['签到状态']) {
            this.showQiandao = false
            this.titleAction = [{
              key: 'qiandaoCheck',
              icon: 'icon-duocengshujuxiaoyan'
            }]
          }
          item.checked = false
          item['签到状态文字'] = item['签到状态'] === '1' || item['签到状态'] === '1' ? '已签到' : ''
          item['更改油品文字'] = item['更改油品'] === '1' ? '已更改' : ''
          item['拉黑状态'] = item['BLACK'] === 'black' ? '已拉黑' : ''
        })
        this.carList = data
        this.loading = false
      })
    },
    setGasXz () {
      let gasCodeStr = ''
      this.xzGasList.forEach((item) => {
        gasCodeStr += item['油站代码'] + ','
      })
      let parm = {
        action: 'set_car_gas_xz',
        data: {
          'xz_gas': gasCodeStr.slice(0, -1),
          'car_id': this.carMap['车牌号']
        }
      }
      car(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送指定油站成功'
          })
          this.carMap['可配送油站限制'] = gasCodeStr.slice(0, -1)
          this.showGasXz = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送指定油站失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送指定油站失败'
        })
      })
    },
    delWCarData (datas) {
      datas.forEach((item) => {
        item['签到状态文字'] = item['签到状态'] === '1' || item['签到状态'] === '1' ? '已签到' : ''
        item['更改油品文字'] = item['更改油品'] === '1' ? '已更改' : ''
        item['拉黑状态'] = item['BLACK'] === 'black' ? '已拉黑' : ''
        let wText = []
        item['WTYPE'].split(',').forEach((item) => {
          wText.push(warningTypes[item])
        })
        item['异常原因'] = wText.join(',')
      })
      return datas
    },
    setCarOilType () {
      let parm = {
        action: 'set_car_oil_change',
        data: this.changeOil
      }
      car(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '更改油品成功'
          })
          this.carMap['更改油品'] = 1
          this.showChange = false
          this.loadCarList()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '更改油品失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '更改油品失败'
        })
      })
    },
    delChangeCarOilType () {
      let parm = {
        action: 'del_car_oil_change',
        data: {'车牌号': this.carMap['车牌号']}
      }
      car(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油品更改删除成功'
          })
          this.carMap['更改油品'] = 0
          this.showChange = false
          this.loadCarList()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油品更改删除失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油品更改删除失败'
        })
      })
    },
    qiandao () {
      this.warningData = []
      this.loadingWarning = true
      this.showCheckData = true
      let checkedList = []
      this.carList.forEach((item) => {
        if (item.checked) {
          checkedList.push({'签到': item['车牌号']})
        }
      })
      let parm = {
        action: 'car_qd',
        data: {
          qdData: checkedList
        }
      }
      car(parm).then((data) => {
        this.warningData = this.delWCarData(data)
        this.loadingWarning = false
        this.loadCarList()
      })
    },
    qiandaoCheck () {
      this.warningData = []
      this.loadingWarning = true
      this.showCheckData = true
      let parm = {
        action: 'car_qd_check',
        data: {}
      }
      car(parm).then((data) => {
        this.warningData = this.delWCarData(data)
        this.loadingWarning = false
      })
    },
    clickTitleMenu (key) {
      if (key === 'add') {
        this.carMap = mapCp(nulCar)
        this.isNew = true
        this.showAdd = true
      } else if (key === 'qiandao') {
        this.qiandao()
      } else if (key === 'qiandaoCheck') {
        this.qiandaoCheck()
      }
    },
    clickTdBtn (dataMap) {
      this.carMap = mapCp(dataMap.data)
      if (dataMap.key === 'del') {
        this.showDel = true
      } else if (dataMap.key === 'edit') {
        this.isNew = false
        this.showAdd = true
      } else if (dataMap.key === 'gq') {
        this.changeQianDao()
      } else if (dataMap.key === 'change_oil_type') {
        this.showChange = true
        if (Number(this.carMap['更改油品']) === 1) {
          this.getChangeInfo()
        } else {
          this.changeOil = mapCp(nulChangeOil)
          this.changeOil['车牌号'] = this.carMap['车牌号']
        }
      } else if (dataMap.key === 'change_gas_xz') {
        this.xzGasList = []
        let gasCodeList = this.carMap['可配送油站限制'] ? this.carMap['可配送油站限制'].split(',') : []
        this.gasList.forEach((item) => {
          if (gasCodeList.indexOf(item['油站代码']) > -1) {
            this.xzGasList.push(item)
          }
        })
        this.showGasXz = true
      } else if (dataMap.key === 'black') {
        this.changeBlack('black')
      } else if (dataMap.key === 'black_back') {
        this.changeBlack('black_back')
      }
    },
    changeBlack (type) {
      this.loading = true
      let parm = {
        action: 'car_change_black',
        data: {
          'carId': this.carMap['车牌号'],
          'status': type === 'black_back' ? 'white' : 'black'
        }
      }
      car(parm).then((data) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        })
        this.loading = false
        this.loadCarList()
      })
    },
    changeQianDao () {
      this.loading = true
      let parm = {
        action: 'car_gaiqian',
        data: {
          'carId': this.carMap['车牌号'],
          'ySatus': this.carMap['签到状态']
        }
      }
      car(parm).then((data) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        })
        this.loading = false
        this.loadCarList()
      })
    },
    getChangeInfo () {
      let parm = {
        action: 'get_car_oil_change',
        data: {
          '车牌号': this.carMap['车牌号']
        }
      }
      car(parm).then((data) => {
        this.changeOil = data.length > 0 ? data[0] : mapCp(nulChangeOil)
      })
    },
    saveCar () {
      if (!this.carMap['车牌号']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '车牌号必填',
          message: '请输入车牌号'
        })
        return
      }
      let parm = {
        action: this.isNew ? 'add_car' : 'edit_car',
        data: this.carMap
      }
      car(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: this.isNew ? '车辆新增完成' : '车辆修改完成'
          })
          this.showAdd = false
          this.loadCarList()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: this.isNew ? '新增油站失败' : '修改油站失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: this.isNew ? '新增油站失败' : '修改油站失败'
        })
      })
    },
    delCar () {
      let parm = {
        action: 'del_car',
        data: {'车牌号': this.carMap['车牌号']}
      }
      car(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '车辆删除成功'
          })
          this.loadCarList()
          this.showDel = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '车辆删除失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '车辆删除失败'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.output-btn {
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content {
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  background-color: #fff;
}
.gas-list {
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-wrap: wrap;
  span {
    padding:0.1rem 0.7rem;
    border-radius: 0.2rem;
    width: auto !important;
    background-color: #eee;
    margin: 0 0.7rem 0.5rem 0;
  }
  .icon-105 {
    margin-left: 0.5rem;
    color: red;
  }
}
.case-form {
  display: flex;
  flex-wrap: wrap;
}
.one-input {
  display: flex;
  justify-content: space-between;
  width: 46%;
  margin: 1rem 2%;
  span {
    width: 9rem;
    font-size: 0.9rem;
  }
}
.xz-gas {
  .one-input {
    width: 100%;
  }
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.gas-info {
  height: 3rem;
  margin-bottom: 1rem;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  .info-one {
    text-align: center;
    flex: 1;
    display: flex;
    align-items: center;
    color: #666;
    font-size: 1.1rem;
    span {
      color: #999;
      margin-right: 1rem;
    }
  }
}
.file-input {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.m-line {
  width: 2px;
  height: 15em;
  background-color: #ccc;
  margin: 1.5em 2.2em 0 0;
}
.output-content-1 {
  flex: 1;
  margin: 1em 2.5em 7em;
  display: flex;

}
.checkbox-content {
  display: flex;
  flex-direction: column;
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
}
.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// car.vue?744cf2bb